import React, { useEffect, useState } from 'react'
import AccessControl from '../../components/AccessControl';
import { Button, Col, Popconfirm, Row, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { findLinkedIotDevice } from './linkedIotDevice';

export default function FuelCalibrationLink({ data, authUser }) {
    const [hasFuelSensorDevice, setHasFuelSensorDevice] = useState(false);
    const [taggedDeviceAsset, setTaggedDeviceAsset] = useState(null);
    const [sensorDeviceAsset, setSensorDeviceAsset] = useState(null);
    const [mainAsset, setMainAsset] = useState(null);

    useEffect(() => {
        // console.log(data);
        const { asset, dependentLinkedAsset, dependentLinkHistory } = data || {};
        // console.log(dependentLinkedAsset, dependentLinkHistory);
        setMainAsset(asset);
        // will use dependentLinkedAsset to find the iot device and fuel sensor (later @todo)

        if (dependentLinkedAsset && dependentLinkedAsset.length) {
            // console.log(dependentLinkedAsset);
            const iotDevice = findLinkedIotDevice(data);
            if (iotDevice) {
                setSensorDeviceAsset(iotDevice.dependents.find(a => a.assetModel && a.assetModel.isFuelSensorDevice));
                setTaggedDeviceAsset(iotDevice);
                setHasFuelSensorDevice(true)
            }
        }



        // if (dependentLinkHistory && dependentLinkHistory.length) {  
        //     const ix = dependentLinkHistory.findIndex(a => a.subasset && a.subasset.assetModel
        //         && a.subasset.assetModel.isTagDevice && a.subasset.tagDeviceId && a.subasset.parent && a.subasset.parent.toString() === asset._id.toString())
        //     // console.log(ix, dependentLinkHistory[ix]);
        //     if (ix >= 0) {
        //         setTaggedDeviceAsset(dependentLinkHistory[ix].subasset);
        //         setHasFuelSensorDevice(true)
        //     }
        // }
    }, [data]);

    return (<>
        {mainAsset &&
            (<div style={{ marginBottom: '0px' }}>

                {taggedDeviceAsset && hasFuelSensorDevice && sensorDeviceAsset &&
                    <AccessControl resource={'Fuel'} permissionNeeded={'c'}
                        roles={authUser ? authUser.roles : []} render={(props) => {
                            return <>
                                <Tooltip placement="topLeft" title={"Fuel Calibration List"}>
                                    <Button className='gx-btn-blue' style={{ marginBottom: 0, marginRight: '3px' }} type='link'>
                                        <Link target='_blank'
                                            to={`/iot/fuel-sensor-calibration/${mainAsset._id}/${taggedDeviceAsset.tagDeviceId}/${sensorDeviceAsset._id}`}>Sensor Calibration ({sensorDeviceAsset.assetCode})</Link></Button>
                                </Tooltip>
                            </>
                        }} />}

                {
                    taggedDeviceAsset &&
                    <Tooltip placement="topLeft" title={"IOT Setting"}>
                        <Button className='gx-btn-blue' style={{ marginBottom: 0, marginRight: '3px' }} type='link'>
                            <Link target='_blank'
                                to={`/iot/setting/${mainAsset._id}/${taggedDeviceAsset.tagDeviceId}`}>Ignition/Idle Setting ({mainAsset.assetCode})</Link></Button>
                    </Tooltip>
                }
            </div >)
        }</>
    )
}
